import React, { useState, useEffect } from 'react';
import CategoryFilter from './CategoryFilter';
import SkillFilter from './SkillFilter';
import ChallengeGrid from './ChallengeGrid';
import SearchBar from './SearchBar';
import { useChallenges } from '../context/ChallengeContext';
import { Category, Difficulty } from '../types';

const ChallengeList: React.FC = () => {
  const { challenges } = useChallenges();
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [selectedSkill, setSelectedSkill] = useState<Difficulty | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredChallenges, setFilteredChallenges] = useState(challenges);

  useEffect(() => {
    const filtered = challenges.filter(challenge => {
      const matchesCategory = !selectedCategory || challenge.category === selectedCategory;
      const matchesSkill = !selectedSkill || challenge.difficulty === selectedSkill;
      const matchesSearch = !searchQuery || 
        challenge.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        challenge.description.toLowerCase().includes(searchQuery.toLowerCase());
      
      return matchesCategory && matchesSkill && matchesSearch;
    });
    
    setFilteredChallenges(filtered);
  }, [selectedCategory, selectedSkill, searchQuery, challenges]);

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-medium mb-6 text-center sm:text-left">Photography Challenges</h2>
        <SearchBar searchQuery={searchQuery} onSearchChange={setSearchQuery} />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <CategoryFilter 
            selectedCategory={selectedCategory} 
            onSelectCategory={setSelectedCategory} 
          />
          <SkillFilter
            selectedSkill={selectedSkill}
            onSelectSkill={setSelectedSkill}
          />
        </div>
      </div>
      
      <div>
        <ChallengeGrid challenges={filteredChallenges} />
        
        {filteredChallenges.length === 0 && (
          <div className="text-center py-10 text-gray-400">
            No challenges found for the selected criteria.
          </div>
        )}
      </div>
    </div>
  );
};

export default ChallengeList;